var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessContactMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    fill: "none",
    strokeMiterlimit: 10,
    d: "M25,33.618V41L9.802,45.342 C6.368,46.323,4,49.463,4,53.034V62h56v-8.966c0-3.572-2.368-6.711-5.802-7.692L39,41v-7.382",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M32,36L32,36 c-7.732,0-14-8.268-14-16v-4c0-7.732,6.268-14,14-14h0c7.732,0,14,6.268,14,14v4C46,27.732,39.732,36,32,36z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    fill: "none",
    strokeMiterlimit: 10,
    d: "M18.019,15.617 C20.105,16.497,22.478,17,25,17c4.915,0,9.264-1.9,12-4.822c2.162,2.309,5.34,3.962,9,4.562",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeMiterlimit: 10,
    x1: 32,
    y1: 57,
    x2: 32,
    y2: 54
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    strokeMiterlimit: 10,
    points: "39,41 32,48 25,41 ",
    strokeLinecap: "butt"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessContactMale);
export default __webpack_public_path__ + "static/media/business_contact_male.e595cddfb2cb8c83707d51bd3fdf143f.svg";
export { ForwardRef as ReactComponent };